import { Component, Output, EventEmitter, ChangeDetectionStrategy, HostListener, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { IconDirective } from 'libs/shared/ui-common/src/lib/components/icon/icon.directive';
import { TooltipDirective } from 'shared/ui-common';
import { GetFromMapPipe } from 'shared/util-common';

import {
  GuidelineSearchResultMatchingField,
  matchingFieldIconMap,
  iconTooltipTranslationKeyMap,
  pathTooltipTranslationKeyMap,
} from '../guideline-search.model';

export type GuidelineSearchResultItem = {
  title: string;
  navigationPath: string;
  snippet: string;
  uniqueId: string;
  matchingField?: GuidelineSearchResultMatchingField;
  matchingFieldUniqueId: string;
  score?: number;
};

export type GuidelineSearchResultItemSelectedEvent = GuidelineSearchResultItem & { goToPath?: boolean; resultPosition?: number };

@Component({
  selector: 'tt-guideline-search-result-item',
  standalone: true,
  imports: [IconDirective, MatIconModule, TranslocoModule, TooltipDirective, GetFromMapPipe],
  templateUrl: './guideline-search-result-item.component.html',
  styleUrls: ['./guideline-search-result-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuidelineSearchResultItemComponent<T extends GuidelineSearchResultItem> {
  public item = input<T>();
  public resultPosition = input<number>();

  @Output() public itemSelected = new EventEmitter<GuidelineSearchResultItemSelectedEvent>();

  @HostListener('click')
  protected onHostClick(): void {
    this.itemSelected.emit({ ...this.item(), resultPosition: this.resultPosition() });
  }

  protected emitPathClicked(event: MouseEvent): void {
    event.stopPropagation();
    this.itemSelected.emit({ ...this.item(), goToPath: true, resultPosition: this.resultPosition() });
  }

  protected matchingFieldIconMap = matchingFieldIconMap;
  protected iconTooltipTranslationKeyMap = iconTooltipTranslationKeyMap;
  protected pathTooltipTranslationKeyMap = pathTooltipTranslationKeyMap;
}
